'use strict';

var actionExecutionEventTypes = {
    stateUpdate: 'jobActionExecution.state.update'
};

module.exports = actionExecutionEventTypes;